import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Blog } from '../../../models/blog';
import { Category } from '../../../models/category';
import { FormControl } from '@angular/forms';
import { CategoryService } from '../../../services/categories.service';
import { ComuniService } from '../../../services/comuni.service';

import { SelectItem } from "primeng/api";
import * as moment from 'moment';
import { Comuni } from 'src/app/models/comuni';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

import { Editor } from 'primeng/editor';
import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-type-form',
    templateUrl: './type-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, Card, ButtonDirective, InputText, Editor, TranslatePipe]
})
export class TypeFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private categoryService = inject(CategoryService);
  private comuniService = inject(ComuniService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  imagePath: any;
  categories: Category;
  category: Category;

  readonly comuni = signal<Comuni>(undefined);

  checked: boolean = true;
  selectedValue: string;

  categoryForm: UntypedFormGroup;

  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedCategories: Category;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }

  }

  ngOnInit() {

    this.comuniService.getAllList().subscribe(
      (data: Comuni) => this.comuni.set(data),
      error => this.error.set(error)
    );

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {

      this.pageTitle.set('Modifica Tipo di Prenotazione');
      this.categoryService.getId(id).subscribe(
        res => {
          this.categoryForm.patchValue({
            name: res.name,
            description: res.description,
            id: res.id
          });

        }
      );
    } else {
      this.pageTitle.set('Create Category');
    }

    this.categoryForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: ['']

    });
  }

  get name() {
    return this.categoryForm.get('name');
    return this.categoryForm.get('description');

  }

  onSubmit() {

    const formData = new FormData();

    formData.append('name', this.categoryForm.get('name').value);
    formData.append('description', this.categoryForm.get('description').value);

    const id = this.categoryForm.get('id').value;

    if (id) {
      this.categoryService.update(formData, id).subscribe(
        res => {
          if (res.status == 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/categories']);
          }
        },
        error => this.error.set(error)
      );
    } else {
      this.categoryService.create(formData).subscribe(
        res => {
          if (res.status === 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/categories']);
          }
        },
        error => this.error.set(error)
      );
    }

  }

}
